import {
  PaymentDocument as ExternalPaymentDocument,
  canDownloadPaymentDocument,
  customerPayoutRequestToDocumentData
} from '@pego/payment-document-export';
import { documentTenant } from '@tenant/pdf';

import type { CustomerUserOrganisation, PayoutRequest } from 'api';

type PaymentDocumentProps = {
  payout: PayoutRequest;
  organisation: CustomerUserOrganisation;
};

export const PaymentDocument = ({
  payout,
  organisation
}: PaymentDocumentProps) => {
  const data = customerPayoutRequestToDocumentData(
    payout,
    organisation.ordering_institution
  );
  return <ExternalPaymentDocument data={data} tenant={documentTenant} />;
};

export { canDownloadPaymentDocument };
